import React, { useCallback, useEffect, useMemo, useState } from 'react';
import stations from '../data/stations.json';
import {
  DEFAULT_MAP_POSITION,
  filterLocation,
  getMarkerIcon,
} from '../utils/map';
import { getDistanceFromPosition } from '../utils/distance';

const useLocations = ({
  mapRef,
  activeTypeId,
  activeFilterIds,
  activeFilterProductIds,
}) => {
  const [userPosition, setUserPosition] = useState();

  const locationInitialization = useMemo(() => {
    return stations.map((station) => {
      return {
        distanceFromInKms: null,
        ...station,
      };
    });
  }, [stations]);

  const locations = useMemo(() => {
    let updatedStations = locationInitialization
      .filter((location) =>
        filterLocation(
          location,
          activeTypeId,
          activeFilterIds,
          activeFilterProductIds
        )
      )
      .map((station) => {
        const distanceFromInKms = null;

        if (userPosition) {
          station.distanceFromInKms = getDistanceFromPosition(
            station,
            userPosition
          );
        }
        return {
          distanceFromInKms,
          ...station,
        };
      });

    if (userPosition) {
      updatedStations = updatedStations.sort(
        (a, b) => a.distanceFromInKms - b.distanceFromInKms
      );
    }

    return updatedStations;
  }, [
    locationInitialization,
    userPosition,
    activeFilterProductIds,
    activeFilterIds,
    activeTypeId,
  ]);

  const handleUpdateUserPosition = useCallback(
    (position) => {
      console.log('updating user position');
      setUserPosition(position);

      if (mapRef) {
        mapRef.current?.panTo(position);
        mapRef.current?.setZoom(10);
      }
    },
    [mapRef, locations]
  );

  useEffect(() => {
    const getUserCoords = async () => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const userCoords = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            handleUpdateUserPosition(userCoords);
          },
          (err) => console.log(err)
        );
      }
    };
    getUserCoords();
  }, [setUserPosition]);

  return { locations, userPosition, handleUpdateUserPosition };
};

export default useLocations;
